// extracted by mini-css-extract-plugin
export default {"tableItem":"TableRow_tableItem__-FcNO","text":"TableRow_text__dKH0b","stat":"TableRow_stat__2OY4s","tag":"TableRow_tag__evd+k","tableLine":"TableRow_tableLine__Y-js9"};